import Accordion from '@10up/component-accordion';

new Accordion( '.accordion', {
  onCreate: function() { 
      //console.log('accordion created');
  },
  onOpen: function( accordionElements ) {
      //console.log('accordion opened');
  },
  onClose: function( accordionElements ) { 
      //console.log('accordion closed');
  },
  onToggle: function( accordionElements ) { 
      //console.log('accordion toggle');
  }
} );